import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import { getAnalyticsData } from "helpers/repository"

import {
  Card,
  CardBody,
  CardHeader,
  CardText,
  Col,
  Container,
  Media,
  Row,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { sitename } from "../../../constants/constants"
import CardUser from "./CardUser"
import Transactions from "./transactions"
import { FiltersCard } from "components/Common/FiltersCard"
import TableLoader from "components/Common/TableLoader"

const Analytics = props => {
  const today = new Date().toISOString().split("T")[0]
  const [fromDate, setFromDate] = useState(today)
  const [toDate, setToDate] = useState(today)
  const [transactions, settransactions] = useState([])
  const [carduser, setcarduser] = useState([])
  const [visitors, setvisitors] = useState([])

  const call = () => {
    settransactions([])
    setcarduser([])
    setvisitors([])
    const payload = {
      from: fromDate,
      to: toDate,
    }
    getAnalyticsData(primaryCallback, error, payload)
  }
  useEffect(() => {
    call()
  }, [])

  const primaryCallback = res => {
    setcarduser(res)
    settransactions(res)
    setvisitors(res)
  }
  const error = err => {
    console.log(err)
  }

  function formatNumber(num) {
    return num.toLocaleString()
  }
  // const
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Analytics" />
        </Container>
        <Row>
          <Col xl="12">
            <Row>
              <Col md="4">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <Media>
                      <Media body>
                        <p className="text-muted fw-medium">Visitors</p>
                        <h4
                          className="mb-0"
                          title={`${visitors.visitors ?? 0} Visitors`}
                        >
                          {formatNumber(visitors.visitors ?? 0)}
                        </h4>
                      </Media>
                      <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-primary">
                          <i className={"bx bx-trending-up font-size-24"}></i>
                        </span>
                      </div>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4" key={"_col_2"}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <Media>
                      <Media body>
                        <p className="text-muted fw-medium">Pageviews</p>
                        <h4
                          className="mb-0"
                          title={`${visitors.pageviews ?? 0} Page Views`}
                        >
                          {formatNumber(visitors.pageviews ?? 0)}
                        </h4>
                      </Media>
                      <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-primary">
                          <i className={"bx bx-task font-size-24"}></i>
                        </span>
                      </div>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4" key={"_col_3"}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <Media>
                      <Media body>
                        <p className="text-muted fw-medium">Time on Page</p>
                        <h4
                          className="mb-0"
                          title={`${
                            visitors.seconds_on_page ?? 0
                          } Seconds on Page`}
                        >
                          {visitors.seconds_on_page ?? 0} s
                        </h4>
                      </Media>
                      <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-primary">
                          <i className={"bx bx-user-circle font-size-24"}></i>
                        </span>
                      </div>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <FiltersCard
          fromDate={fromDate}
          toDate={toDate}
          setToDate={setToDate}
          setFromDate={setFromDate}
          showToDate={true}
          call={() => {
            call()
          }}
          notDisplayFilter={true}
          hideShowType={false}
        />
        {carduser.length === 0 ? (
          <TableLoader />
        ) : (
          <div>
            <CardUser
              dataColors='["--bs-primary", "--bs-warning"]'
              data={carduser}
            />
            <Transactions data={transactions} />
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default withRouter(Analytics)
